














































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import { normalizeSearch, plural } from '@/services/browse-and-go/labels'
import { bngState, deleteSelection } from '@/services/browse-and-go/store'
import { Merchant } from '@/services/browse-and-go/types'

@Component({
  name: 'BrowseAndGoSelections',
  components: { PageHeader }
})
export default class extends Vue {
  private plural = plural
  private merchantQuery = ''
  private category = ''
  private pickedIds: string[] = []

  get categories() {
    return bngState.categories
  }

  get selections() {
    return bngState.selections
  }

  get filteredMerchants() {
    const needle = normalizeSearch(this.merchantQuery)
    return [...bngState.merchants]
      .filter(merchant => {
        if (this.category && !merchant.categories.includes(this.category)) return false
        if (!needle) return true
        return normalizeSearch(merchant.name).includes(needle)
      })
      .sort((a, b) => a.name.localeCompare(b.name, 'fr'))
  }

  get allMerchantsSelected() {
    return this.filteredMerchants.length > 0 &&
      this.filteredMerchants.every(merchant => this.pickedIds.includes(merchant.id))
  }

  private onPick(rows: Merchant[]) {
    this.pickedIds = rows.map(row => row.id)
  }

  private toggleAllMerchants() {
    const table = this.$refs.catalog as Vue & {
      toggleRowSelection: (row: Merchant, selected?: boolean) => void
    }
    if (!table) return
    const selected = !this.allMerchantsSelected
    this.filteredMerchants.forEach(row => table.toggleRowSelection(row, selected))
  }

  private createFromPicked() {
    if (!this.pickedIds.length) return
    this.$router.push({
      name: 'BrowseAndGoSelectionCreate',
      query: { items: this.pickedIds.join(',') }
    })
  }

  private open(id: string) {
    this.$router.push({ name: 'BrowseAndGoSelectionEdit', params: { id } })
  }

  private remove(id: string) {
    this.$confirm(
      'Supprimer cette sélection enregistrée ? Les modèles déjà composés ne seront pas modifiés.',
      'Supprimer',
      { type: 'warning', confirmButtonText: 'Supprimer', cancelButtonText: 'Annuler' }
    ).then(() => {
      deleteSelection(id)
      this.$message.success('Sélection supprimée')
    }).catch(() => undefined)
  }
}
